import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('BlacklistReason')
export class BlacklistReason {
  @JsonProperty('code', String, true) code: string = undefined;
  @JsonProperty('name', String, true) name: string = undefined;
}
